import React from 'react';
import Loader from "react-js-loader";

function ProcessLoader(props) {
          return (
                    <div className='table-loader'> 
                              <Loader type="box-up" bgColor={"#00aeef"} title={"loading...."} size={100} />

                    </div>
          )
}

export default ProcessLoader